export const isArray = (value: unknown): value is unknown[] => Array.isArray(value);

export const isString = (value: unknown): value is string => typeof value === 'string';

export const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && !Number.isNaN(value);

export const isObject = (value: unknown): value is Record<PropertyKey, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const assertUnreachable = (value: never): never => {
  throw new Error(`Unhandled case: ${JSON.stringify(value)}`);
};
